































import { PropType } from 'vue';
import { defineComponent, toRefs, computed, watch } from '@vue/composition-api';
import { AdgroupFormData, CampaignFormData, AdgroupConfig, FlowControlMode } from '@tt4b/ttam-enums';
import { trackEvent } from './../../../utils/index';
import DeliveryType from './index';

const name = 'ttam-delivery-type-compose';
export default defineComponent({
  name,
  components: {
    TtamDeliveryTypeLabel: DeliveryType.TtamDeliveryTypeLabel,
    TtamDeliveryTypeLabelHint: DeliveryType.TtamDeliveryTypeLabelHint,
    TtamDeliveryTypeCboInfo: DeliveryType.TtamDeliveryTypeCboInfo,
    TtamDeliveryTypeOptions: DeliveryType.TtamDeliveryTypeOptions,
    TtamDeliveryTypePlainOption: DeliveryType.TtamDeliveryTypePlainOption,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
      required: true,
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
      required: true,
    },
    adgroupConfig: {
      type: Object as PropType<AdgroupConfig>,
      default: () => ({}),
      required: true,
    },
  },
  setup(props, { emit }) {
    const { adgroupData, campaignData, adgroupConfig } = toRefs(props);
    const { options: flowControlModes } = DeliveryType.useOptionsPropsFlowControlModes({
      adgroupData,
      campaignData,
      adgroupConfig,
    });

    const { visible: cboTipsVisible } = DeliveryType.useCboInfoPropsVisible({ adgroupData, campaignData });

    const _flowControlMode = computed({
      get: () => props.adgroupData?.flowControlMode,
      set: val => emit('change', val),
    });

    const currentFlowControlMode = computed(
      () => flowControlModes.value.find(item => item.value === _flowControlMode.value) || {},
    );

    // 少于等于1个选项时，显示plainText样式
    const isPlainText = computed(() => flowControlModes.value?.filter(mode => !mode.disabled).length <= 1);

    const { supportAccelerate } = DeliveryType.useCheckIfSupportAccelerate({
      adgroupData,
      campaignData,
    });

    const handleControlMode = () => {
      if (!supportAccelerate.value) {
        _flowControlMode.value = FlowControlMode.STANDARD;
      }
    };

    const iconHoverTrack = () => trackEvent('adgroup_delivery_type_hover');

    watch(
      supportAccelerate,
      () => {
        handleControlMode();
      },
      {
        immediate: true,
      },
    );

    return {
      name,
      cboTipsVisible,
      flowControlModes,
      _flowControlMode,
      iconHoverTrack,
      currentFlowControlMode,
      isPlainText,
    };
  },
});
